import React from 'react';

export default function ChatBackdrop({ onClose }) {
  return <div className="chatbox-backdrop" onClick={onClose} aria-hidden="true" />;
}
